import { canUseDom } from '@argos/utils'

const environment = process.env.NODE_ENV || 'production'

/**
 * Return the URL for the websocket servlet.
 *
 * @return {String} the websocket url
 */
export const getWebSocketUrl = () =>
  environment === 'development' || (canUseDom() && window.location.host.indexOf('dev.deveng') > -1)
    ? 'wss://pre-prod-live-chat-websocket-interceptor.service.eu-west-1.staging.deveng.systems/v2'
    : 'wss://chat.argos.co.uk/webchat/socket/v2'

/**
 * Return the CMC status URL
 * @return {String} the endpoint for the CMC status service
 */
export const getCmcStatusUrl = () =>
  environment === 'development' || (canUseDom() && window.location.host.indexOf('dev.deveng') > -1)
    ? 'https://pre-prod-oceana-chat.service.eu-west-1.staging.deveng.systems/open'
    : 'https://chat.argos.co.uk/webchat/open'

export default {
  getWebSocketUrl,
  getCmcStatusUrl,
}
